<template>
  <div>
    <!-- begin #header -->
    <div id="header" class="header navbar-default">
      <!-- begin navbar-header -->
      <div class="navbar-header">
        <button
          type="button"
          class="navbar-toggle pull-right"
          v-on:click="toggleMobileRightSidebar"
          v-if="pageOptions.pageWithTwoSidebar"
        >
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </button>
        <button
          type="button"
          class="navbar-toggle pull-left"
          v-on:click="toggleMobileSidebar"
          v-if="pageOptions.pageWithTwoSidebar"
        >
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </button>
        <router-link to="/home" class="navbar-brand">
          <a-icon type="home" :style="{ display: 'inline-flex' }" />
          {{ appName }}
        </router-link>
        <button
          type="button"
          class="navbar-toggle"
          v-on:click="toggleMobileSidebar"
          v-if="
            !pageOptions.pageWithTwoSidebar &&
            !pageOptions.pageWithTopMenu &&
            !pageOptions.pageWithoutSidebar
          "
        >
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </button>
        <button
          type="button"
          class="navbar-toggle"
          v-on:click="toggleMobileTopMenu"
          v-if="pageOptions.pageWithTopMenu && pageOptions.pageWithoutSidebar"
        >
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </button>
        <button
          type="button"
          class="navbar-toggle p-0 m-r-0"
          v-on:click="toggleMobileMegaMenu"
          v-if="pageOptions.pageWithMegaMenu"
        >
          <span class="fa-stack fa-lg text-inverse m-t-2">
            <i class="far fa-square fa-stack-2x"></i>
            <i class="fa fa-cog fa-stack-1x"></i>
          </span>
        </button>
      </div>
      <!-- end navbar-header -->

      <header-mega-menu v-if="pageOptions.pageWithMegaMenu"></header-mega-menu>

      <!-- begin header-nav -->
      <ul class="navbar-nav navbar-right">
        <li
          v-if="!pageOptions.pageWithLanguageBar"
          v-bind:class="{ 'hidden-sm': pageOptions.pageWithMegaMenu }"
        >
          <form class="navbar-form" v-on:submit="checkForm">
            <div class="form-group">
              <input
                type="text"
                class="form-control"
                placeholder="Enter keyword"
              />
              <button type="submit" class="btn btn-search">
                <i class="fa fa-search"></i>
              </button>
            </div>
          </form>
        </li>
        <li class="dropdown navbar-user mr-2" v-if="branch">
          <b-dropdown
            :disabled="loading"
            variant="link"
            menu-class="dropdown-menu-right"
            class="user-dropdown-header"
          >
            <template slot="button-content">
              <i
                v-if="saving"
                class="fas fa-circle-notch d-inline-block spin"
              />
              <i v-else class="fa fa-building"></i>
              <span class="ml-2 d-none d-md-inline"
                ><b>{{ branch }}</b></span
              >
              <b class="caret"></b>
            </template>
            <b-dropdown-item
              v-for="(branches, index) in groupBy(branchProfiles, 'company_id')"
              :key="index"
            >
              <p class="text-success ts-font-bold">
                &bull; {{ branches[0].company.company_name_en }}
              </p>
              <a
                href="#"
                class="ml-2"
                v-for="(branch, index) in branches"
                :key="index"
                @click.prevent="checkCashierLocation(branch)"
              >
                <span class="mr-2"><i class="far fa-building"></i></span>
                {{ branch.branch_name_en }}<br />
              </a>
            </b-dropdown-item>
          </b-dropdown>
        </li>
        <li class="dropdown">
          <b-dropdown
            variant="link"
            menu-class="media-list dropdown-menu-right"
            toggle-class="f-s-14"
          >
            <template slot="button-content">
              <i class="fa fa-bell"></i>
              <span class="label">0</span>
            </template>
            <b-dropdown-header>NOTIFICATIONS (0)</b-dropdown-header>
            <li class="text-center width-300 p-b-10">No notification found</li>
          </b-dropdown>
        </li>
        <li
          class="dropdown navbar-language"
          v-if="pageOptions.pageWithLanguageBar"
        >
          <b-dropdown variant="link" menu-class="p-b-0">
            <template slot="button-content">
              <span :class="`flag-icon flag-icon-${flag}`" :title="flag"></span>
            </template>
            <b-dropdown-item
              href="#"
              v-for="language in languages"
              :key="language.code"
              @click="changeLanguage(language)"
            >
              <span
                :class="`flag-icon flag-icon-${language.icon}`"
                :title="language.icon"
              ></span>
              {{ language.caption }}
            </b-dropdown-item>
          </b-dropdown>
        </li>
        <li class="dropdown navbar-user" v-if="isParent">
          <b-dropdown
            variant="link"
            menu-class="dropdown-menu-right"
            class="user-dropdown-header"
          >
            <template slot="button-content">
              <span class="d-none d-md-inline">{{
                selectedStudent.full_name_en
              }}</span>
              <div class="image image-icon bg-black text-grey-darker">
                <img :src="selectedStudent.photo" alt="" />
              </div>
              <b class="caret"></b>
            </template>
            <b-dropdown-item
              href="#"
              v-for="(child, index) in children"
              :key="index"
              @click.prevent="pickChild(child)"
            >
              <span class="mr-2"><i class="far fa-user"></i></span>
              {{ child.full_name_en }}
            </b-dropdown-item>
          </b-dropdown>
        </li>
        <li class="dropdown navbar-user">
          <b-dropdown
            variant="link"
            menu-class="dropdown-menu-right"
            class="user-dropdown-header"
          >
            <!-- style="border-color:hsl(214, 100%, 59%);border-width: 4px;" -->
            <template slot="button-content">
              <img
                class="ts-rounded-full ts-w-30 ts-h-30 ts-flex ts-items-center ts-justify-center ts-object-cover"
                v-lazy="{
                  src: userProfile,
                  error: require('@/assets/default_user.png'),
                  loading: require('@/assets/Rolling-1s-200px_2.svg')
                }"
                alt=""
                :class="{ 'external-user': is_external }"
              />
              <span class="d-none d-md-inline">{{ userName }}</span>
              <b class="caret"></b>
            </template>

            <b-dropdown-item
              href="#"
              @click.prevent="$router.push({ name: 'calendar' })"
              >Calendar</b-dropdown-item
            >
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item href="#" @click="logout">Log Out</b-dropdown-item>
          </b-dropdown>
        </li>
        <li class="divider d-none d-md-block" v-if="isHris"></li>
        <li class="d-none d-md-block" v-if="isHris">
          <a @click.prevent="switchToHris" class="f-s-14">
            <i class="fa fa-th"></i>
            HRIS
          </a>
        </li>
      </ul>
      <!-- end header navigation right -->
    </div>
    <!-- end #header -->
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import PageOptions from '../../config/PageOptions.vue'
import HeaderMegaMenu from './HeaderMegaMenu.vue'
import ChooseLocationComponent from './ChooseLocation.vue'
import SwitchToHrisComponent from './SwitchToHris.vue'

export default {
  name: 'Header',
  components: {
    HeaderMegaMenu
  },
  data () {
    return {
      pageOptions: PageOptions,
      languages: [
        { code: 'kh', icon: 'kh', caption: 'ខ្មែរ' },
        { code: 'en', icon: 'us', caption: 'English' }
      ],
      branches: [],
      loading: false,
      saving: false,
      default_user: require('../../assets/default_user.png')
    }
  },
  computed: {
    userProfile () {
      return this.$store.state.authUser
        ? this.$store.state.authUser.user_profile
          ? this.$store.state.authUser.user_profile
          : this.default_user
        : ''
    },
    branch () {
      return this.$store.state.authUser
        ? this.$store.state.authUser.default_branch
        : null
    },
    userName () {
      return this.$store.state.authUser
        ? this.$store.state.authUser.full_name
        : ''
    },
    is_external () {
      return this.$store.state.authUser
        ? this.$store.state.authUser.is_external
        : false
    },
    flag () {
      if (this.$root.$i18n.locale === 'kh') return 'kh'
      else if (this.$root.$i18n.locale === 'en') return 'us'
    },
    children () {
      return this.$store.getters.children
    },
    selectedStudent () {
      return this.$store.state.selectedStudent
    },
    isParent () {
      return this.$store.getters.isParentLogin
    },
    branchProfiles () {
      return this.branches.filter(
        b => b.branch_id !== this.$store.state.authUser.default_branch_id
      )
    },
    appName () {
      if (this.$store.state.authUser) {
        if (this.$store.state.authUser.company) {
          return this.$store.state.authUser.company.prefix + ' School ERP'
        }
        return ' School ERP'
      }
      return 'School ERP'
    },
    isParent () {
      return this.$store.getters.isParentLogin
    },
    isHris () {
      if (this.$store.state.authUser) {
        if (this.$store.state.authUser.company) {
          return this.$store.state.authUser.company.is_hris
        }
      }

      return false
    }
  },
  created () {
    this.fetchBranch()
  },
  methods: {
    ...mapActions('user', ['getBranch']),
    toggleMobileSidebar () {
      this.pageOptions.pageMobileSidebarToggled =
        !this.pageOptions.pageMobileSidebarToggled
    },
    toggleMobileRightSidebar () {
      this.pageOptions.pageMobileRightSidebarToggled =
        !this.pageOptions.pageMobileRightSidebarToggled
    },
    toggleMobileTopMenu () {
      this.pageOptions.pageMobileTopMenu = !this.pageOptions.pageMobileTopMenu
    },
    toggleMobileMegaMenu () {
      this.pageOptions.pageMobileMegaMenu = !this.pageOptions.pageMobileMegaMenu
    },
    toggleRightSidebar () {
      this.pageOptions.pageRightSidebarToggled =
        !this.pageOptions.pageRightSidebarToggled
    },
    checkForm: function (e) {
      e.preventDefault()
      this.$router.push({ path: '/extra/search' })
    },
    async logout () {
      await this.$store.dispatch('logout')
      this.$router.push({ name: 'login' })
    },
    changeLanguage (language) {
      this.$root.$i18n.locale = language.code
    },
    pickChild (child) {
      this.$store.commit('SET_SELECTED_STUDENT', child)
    },
    checkCashierLocation (data) {
      if (!this.$store.state.authUser.cashier_location_id) {
        return this.pickDefaultBranch(data)
      }
      this.$modal.show(
        ChooseLocationComponent,
        {
          data: data
        },
        {
          height: 'auto',
          width: '300px',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        }
      )
    },
    async pickDefaultBranch (branch) {
      this.saving = true
      await this.$store
        .dispatch('user/switchDefaultBranch', {
          branch_id: branch.branch_id,
          location_id: null
        })
        .then(async response => {
          this.$Message.success({
            background: true,
            content: response.message
          })
          await this.fetchUser()
          const searchURL = new URL(window.location)
          if (searchURL.origin === branch.company.system_url) {
            setTimeout(
              (window.location.href =
                branch.company.system_url + this.$route.path),
              3000
            )
          } else {
            this.logout()
          }
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.saving = false
        })
    },
    async fetchBranch () {
      this.loading = true
      await this.getBranch({
        filter: {
          user_branches: 1
        }
      }).then(response => {
        this.branches = response.data
        this.loading = false
      })
    },
    groupBy (array, key) {
      const result = {}
      array.forEach(item => {
        if (!result[item[key]]) {
          result[item[key]] = []
        }
        result[item[key]].push(item)
      })
      return result
    },
    switchToHris () {
      this.$modal.show(
        SwitchToHrisComponent,
        {
          data: null
        },
        {
          height: 'auto',
          width: '350px',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        }
      )
    },
    async fetchUser () {
      await this.$store
        .dispatch('user/getCurrentUser')
        .then(response => {
          if (response) {
            this.$store.commit('setAuthUser', {
              user_name: response.user_name,
              full_name: response.full_name,
              access_token: response.access_token,
              permission_allow_code: response.permission_allow_code,
              user_type: response.user_type,
              guardian_type_id: response.guardian_type_id,
              permissions: response.permissions,
              default_branch: response.default_branch,
              default_branch_id: response.default_branch_id,
              user_profile: response.user_profile,
              cashier_location_id: response.cashier_location_id,
              children: response.children,
              company: response.company,
              is_external: response.is_external
            })
          }
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    }
  }
}
</script>

<style scoped>
img {
  object-fit: cover;
  object-position: top;
  height: auto !important;
}
.external-user {
  border-color: hsl(214, 100%, 59%);
  border-width: 4px;
}
</style>

<style lang="sass">
@media (min-width: 768px)
  .header
    display: flex !important
    flex-direction: row !important
    align-items: center !important

    .navbar-header
      flex-grow: 1 !important

  .header .navbar-right
    display: flex !important
    flex-direction: row !important
    align-items: center !important

  .user-dropdown-header button
    display: flex !important
    justify-content: center !important
    align-items: center !important

    .image.image-icon
      margin: 0 3px !important
</style>
